import { SvgIcon } from '@material-ui/core';

export const ClockIcon = (
  <SvgIcon>
    <path
      d="M1296,168a12,12,0,1,1,12-12A12,12,0,0,1,1296,168Zm0-22a10,10,0,1,0,10,10A10,10,0,0,0,1296,146Zm2.23,13.7-2.93-2.939a1.008,1.008,0,0,1-.3-0.774V151a1,1,0,0,1,2,0v4.531l2.7,2.7A1.039,1.039,0,1,1,1298.23,159.7Z"
      transform="translate(-1284 -144)"
    />
  </SvgIcon>
);
